import React from 'react';

const StatistiquesSAPStyle = () => {
    return (
        <style>{`
            .sap-page-header {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                border-radius: 16px;
                padding: 32px 40px;
                margin-bottom: 24px;
                box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
            }

            .sap-page-header .header-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .sap-page-header h1 {
                color: white;
                font-size: 28px;
                font-weight: 700;
                margin: 0 0 8px 0;
                display: flex;
                align-items: center;
                gap: 12px;
            }

            .sap-page-header p {
                color: rgba(255,255,255,0.85);
                font-size: 14px;
                margin: 0;
            }

            .filters-card {
                border-radius: 12px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.08);
            }

            .filter-item label {
                display: block;
                font-size: 12px;
                font-weight: 600;
                color: #666;
                margin-bottom: 8px;
            }

            .stat-card {
                border-radius: 12px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                transition: all 0.3s ease;
            }

            .stat-card:hover {
                box-shadow: 0 4px 16px rgba(0,0,0,0.12);
                transform: translateY(-2px);
            }

            .stat-card-highlight {
                background: linear-gradient(135deg, #f5f0ff 0%, #efe6ff 100%);
                border: 1px solid #d3adf7;
            }

            .beneficiaire-card {
                background: #fafafa;
                border-radius: 12px;
                padding: 16px;
                text-align: center;
                border: 1px solid #f0f0f0;
                transition: all 0.3s ease;
            }

            .beneficiaire-card:hover {
                box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                border-color: #d9d9d9;
            }

            .beneficiaire-header {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                font-weight: 600;
                color: #1a365d;
                margin-bottom: 8px;
            }

            .beneficiaire-taux {
                font-size: 12px;
                color: #888;
                margin-bottom: 8px;
            }

            .beneficiaire-montant {
                font-size: 20px;
                font-weight: 700;
                color: #722ed1;
                margin-bottom: 12px;
            }

            .beneficiaire-percent {
                font-size: 11px;
                color: #999;
                margin-top: 8px;
            }

            .ant-table-thead > tr > th {
                background: #f8f9fa !important;
                font-weight: 600;
                font-size: 12px;
            }

            .ant-tabs-tab {
                font-weight: 500;
            }

            .ant-tabs-tab-active {
                font-weight: 600;
            }

            @media (max-width: 768px) {
                .sap-page-header .header-content {
                    flex-direction: column;
                    gap: 16px;
                    text-align: center;
                }

                .sap-page-header {
                    padding: 24px;
                }

                .sap-page-header h1 {
                    font-size: 22px;
                }
            }
        `}</style>
    );
};

export default StatistiquesSAPStyle;